// ignore-string-externalization

const hasWindow = typeof window === 'object';

const ga = (...args) => {
  // console.log("GA", ...args);
  if (hasWindow && window.ga) {
    window.ga(...args);
  }
};

if (hasWindow && process.env.REACT_APP_GA_TRACKING_ID) {
  /* eslint-disable */
  // prettier-ignore
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
  /* eslint-enable */

  ga('create', process.env.REACT_APP_GA_TRACKING_ID, 'auto');
}

export const setDimension = (n, val) => {
  ga('set', `dimension${n}`, val);
};

export const setUserId = partnerId => {
  ga('set', 'userId', partnerId);
};

export const pageView = () => {
  if (hasWindow) {
    // console.log('page view', window.document.location.pathname);
    ga('set', 'page', window.document.location.pathname);
    ga('send', 'pageview');
  }
};

export const sendEvent = opts => {
  ga('send', {
    ...opts,
    hitType: 'event',
    transport: 'beacon',
  });
};
